const Alert = {
  init() {
    this.reveal();
  },

  reveal() {
    const alerts = document.querySelectorAll('.alert-floating');

    let delay = 1000; // milliseconds
    let showTime = 5000; // milliseconds

    alerts.forEach(function(alert) {
      setTimeout(() => {
        alert.classList.add('alert-floating--show');

        let stateWidth = 100;
        let state = alert.querySelector('.alert-floating--show-state')
        let intervalId = setInterval(() => {
          if (stateWidth > 0) {
            stateWidth -= 1;
            state.style.width = stateWidth + '%';  
          }
        }, showTime / 100);

        setTimeout(() => {
          alert.classList.remove('alert-floating--show');
          setTimeout(() => { alert.parentNode.removeChild(alert); }, 1000);
          clearInterval(intervalId);
        }, showTime + 1000);

      }, delay);
    });
  },

  show(type, message) {
    window.document.body.insertAdjacentHTML('beforeend', this.template(type, message))
    this.reveal();
  },

  template: (type, message) => { 
    let typeClass = 'alert-primary';
    if (type.toLowerCase() == 'error') {
      typeClass = 'alert-danger';
    }

    return `<div class="alert ${typeClass} alert-floating" role="alert">
      <p>${message}</p>
      <div class="alert-floating--show-state"></div>
    </div>`
  }
};

Alert.init();

window.Alert = Alert;